import history from 'util/History';

import { useEffect } from 'react';

import F5NetworksRoutes from './common/Routes';

type Props = { url: string };

// https://stackoverflow.com/questions/52912238/render-methods-should-be-a-pure-function-of-props-and-state

const F5NetworksInputConfiguration: React.FC<Props> = ({
  url = F5NetworksRoutes.INTEGRATIONS.F5Networks.ACTIVITYAPI.index,
}) => {
  useEffect(() => {
    history.push(url);
  }, [url]);

  return null;
};

export default F5NetworksInputConfiguration;
